<template lang="pug">
    page(:loading="$wait.waiting(keys.users.read)" like-form)
        template(#title="")
            v-layout(wrap align-center justify-space-between)
                v-flex(grow)
                    e-typography-heading-1 {{ activeUser.firstName }} {{ activeUser.lastName}}
                m-block-user-actions(:item="activeUser" view-type="view")

            v-layout(wrap)
                v-flex(xs12)
                    e-divider-secondary

        template(#content="")
            m-block-user-profile-info(v-if="!isEmptyUser" :item="activeUser")
            m-block-user-contact-info(v-if="!isEmptyUser" :item="activeUser")
            m-block-user-one-time-password-generate(@click:generate-password="generateNewPassword")
            m-dialog-user-generate-password
</template>

<script>
    import Page from "@pages/templates/page";
    import EButtonPrimaryPlus from "@components/elements/buttons/concrete/e-button-primary-plus";
    import MBlockUserActions from "@modules/blocks/actions/concrete/m-block-user-actions";
    import MDialogUserGeneratePassword from "@modules/dialogs/concrete/m-dialog-user-generate-password";
    import MBlockUserProfileInfo from "@modules/blocks/page/concrete/m-block-user-profile-info";
    import MBlockUserContactInfo from "@modules/blocks/page/concrete/m-block-user-contact-info";
    import MBlockUserOneTimePasswordGenerate
        from "@modules/blocks/page/concrete/m-block-user-one-time-password-generate";
    import breadcrumbs from "@mixins/helpers/_breadcrumbs";

    import vuexKeys from "@mixins/includes/_vuexKeys";
    import {mapActions, mapGetters} from 'vuex';
    import isEmpty from 'lodash/isEmpty'
    import dialogs from '@mixins/includes/_dialogs';
    import notifications from "@mixins/includes/_notifications";
    import errorHandler from "@mixins/responses/_errorHandler";

    export default {
        name: "dashboard-account-user",
        mixins: [dialogs, vuexKeys, notifications, breadcrumbs, errorHandler],
        components: {
            Page,
            MDialogUserGeneratePassword,
            EButtonPrimaryPlus,
            MBlockUserActions,
            MBlockUserProfileInfo,
            MBlockUserContactInfo,
            MBlockUserOneTimePasswordGenerate
        },
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.account.users.view.meta.title')
            }
        },
        async created() {
            if (!this.activeUser.length) {
                try {
                    await this.requestUser();
                } catch (e) {
                    this.error.handle(e);
                }
            }
            this.$iBreadcrumbs.setText(`${this.activeUser.firstName} ${this.activeUser.lastName}`);
        },
        computed: {
            ...mapGetters({
                getUser: 'users/read'
            }),
            activeUser() {
                return this.getUser(this.$route.params.id);
            },
            isEmptyUser() {
                return isEmpty(this.activeUser);
            }
        },
        methods: {
            ...mapActions({
                loadUser: 'users/read',
            }),

            requestUser() {
                return this.loadUser({
                    id: this.$route.params.id
                });
            },
            async generateNewPassword() {
                try {
                    await this.openDialog({type: 'generatePassword', options: {user: this.activeUser}});
                } catch (e) {
                    this.notify.error(this.$t('notifications.errors.password.unable'));
                }
            }
        }
    }
</script>

<style scoped>

</style>
